import { createSlice } from '@reduxjs/toolkit'

export const refundSlice = createSlice({
	name: 'refund',
	initialState: {
		isLoading: false,
		mode: null,
		wasCartResponseReceived: false,
		instructions: [],
	},
	reducers: {
		loaderStart: (state) => {
			state.isLoading = true
		},
		loaderStop: (state) => {
			state.isLoading = false
		},
		getCartSuccess: (state, { payload }) => {
			state.isLoading = false
			state.wasCartResponseReceived = true
		},
		getFinalInstructions: (state, { payload }) => {
			state.isLoading = false
			state.instructions = payload
		},
		clearState: (state, { payload }) => {
			state.isLoading = false
			state.mode = null
			state.wasCartResponseReceived = false
			state.instructions = []
		},
	},
})

export const {
	loaderStart,
	loaderStop,
	getCartSuccess,
	getFinalInstructions,
	clearState,
} = refundSlice.actions
export const { reducer } = refundSlice
